export default __webpack_public_path__ + "static/media/werking-wheather.ae0506e1.JPG";